// Portal navigation model — the single source of truth for sidebar nav items.
// Kept dependency-free (no config/DOM imports) so it is unit-testable in Node
// and so the desktop sidebar + mobile drawer share ONE list (never duplicated).

export type NavIcon =
  | 'dashboard' | 'profiles' | 'fields' | 'links' | 'subscribers' | 'contacts' | 'approvals' | 'code' | 'settings';

export interface NavItem { path: string; label: string; icon: NavIcon }

export const NAV: NavItem[] = [
  { path: '/', label: 'Dashboard', icon: 'dashboard' },
  { path: '/fields', label: 'My Info', icon: 'fields' },
  { path: '/profiles', label: 'Profiles', icon: 'profiles' },
  { path: '/links', label: 'Share Links', icon: 'links' },
  { path: '/subscribers', label: 'Subscribers', icon: 'subscribers' },
  { path: '/approvals', label: 'Approvals', icon: 'approvals' },
  { path: '/contacts', label: 'My Contacts', icon: 'contacts' },
  { path: '/code', label: 'Code', icon: 'code' },
  { path: '/settings', label: 'Settings', icon: 'settings' },
];

export const SIGN_OUT_LABEL = 'Sign out';

// approvalsLabelText renders "Approvals" or "Approvals (N)" for N>0. Kept here
// (dependency-free) so shell + tests share one implementation.
export function approvalsLabelText(count: number): string {
  return count > 0 ? `Approvals (${count})` : 'Approvals';
}

// approvalsBannerText renders the sticky banner copy (singular/plural).
export function approvalsBannerText(count: number): string {
  return count === 1 ? 'You have 1 pending Approval' : `You have ${count} pending Approvals`;
}

/** Plain-data view of the shared sidebar content (nav + sign out). */
export function sidebarItems(): { navPaths: string[]; navLabels: string[]; signOutLabel: string } {
  return { navPaths: NAV.map((n) => n.path), navLabels: NAV.map((n) => n.label), signOutLabel: SIGN_OUT_LABEL };
}
